<template>
    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
        min-width="auto">
        <template v-slot:activator="{ props }">
            <!-- `clearable` draws the × but the field is bound one-way, so
                 without this the value came straight back on the next render
                 and a date could be set but never removed. -->
            <v-text-field :loading="loading" :disabled="disabled" variant="outlined" density="compact"
                :model-value="modelValue" :label="label" prepend-icon="mdi-calendar" readonly clearable
                @click:clear="$emit('update:modelValue', null)"
                v-bind="props"></v-text-field>
        </template>
        <v-date-picker :model-value="adaptedDate" @update:model-value="touch" show-week no-title scrollable>
        </v-date-picker>
    </v-menu>
</template>

<script>
import { useDate } from "vuetify"


export default {
    props: ["modelValue", "label", "loading", "disabled", "class"],
    emits: ["update:modelValue"],
    data: () => ({
        // selected_date: useDate(),
        menu: false,
        date_adapter: useDate(),
    }),
    computed: {
        adaptedDate() {
            if (this.modelValue && this.date_adapter.isValid(this.modelValue)) {
                return this.date_adapter.parseISO(this.modelValue)
            }
            else {
                return null
            }
        }
    },
    methods: {
        touch(v) {
            this.$emit("update:modelValue", this.date_adapter.toISO(v));
            this.menu = false;
        },
    },
};
</script>